import type {Description} from './data/types';

import isNonEmptyString from '../../isNonEmptyString';
import useAppTheme from '../design_system/hooks/useAppTheme';
import ParagraphText from '../design_system/typography/ParagraphText';
import TitleText from '../design_system/typography/TitleText';
import Typography, {Size} from '../design_system/typography/Typography';
import Flex from '../layout/flex/Flex';

import {css} from '@emotion/react';
import {SerializedStyles} from '@emotion/serialize';
import React from 'react';

export interface Props {
  readonly description: Description;
  readonly style?: boolean | SerializedStyles;
}

export default function DetailDescription(props: Props): JSX.Element {
  const {description, style} = props;
  const {spacing} = useAppTheme();

  return (
    <div css={style}>
      {description.heading != null && (
        <Typography
          css={css({
            marginBottom: spacing.x16,
          })}
          size={Size.XL}
          variant="h2"
          weight={700}
        >
          {description.heading}
        </Typography>
      )}

      <Flex
        css={css({
          rowGap: spacing.x20,
          alignItems: 'flex-start',
        })}
        direction="column"
      >
        {description.paragraphs.map((item, i) => {
          return (
            <div key={i}>
              {isNonEmptyString(item.heading) && (
                <TitleText size="S">{item.heading}</TitleText>
              )}
              <ParagraphText size="L">{item.content}</ParagraphText>
            </div>
          );
        })}
      </Flex>
    </div>
  );
}
